import { useState, useEffect } from 'react';
import { fetchPartnerClients } from 'admin/actions/partner-client';
import { toQueryParams } from 'admin/utils';

const removeEmptyValues = (obj) => {
  const removed = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] !== '' && obj[k] !== null && obj[k] !== undefined) {
      removed[k] = obj[k];
    }
  });
  return removed;
};

const usePartnerClients = (initQuery = {}) => {
  const [partnerClients, setPartnerClients] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, max_page: 1 });
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});

  const getPartnerClients = async (query = {}) => {
    setIsLoading(true);
    setError({});

    const removed = removeEmptyValues(query);

    await fetchPartnerClients(toQueryParams(removed)).then((data) => {
      setPartnerClients(data.rows);
      setPagination(data.pagination);
      setCount(data.count);
    }).catch((err) => {
      setError(err);
    }).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getPartnerClients(initQuery);
  }, []);

  return [isLoading, partnerClients, pagination, count, error, getPartnerClients];
};

export default usePartnerClients;
